import { firebaseApp } from "../../firebase/firebase";
import {
  CREATE_TASK,
  DELETE_TASK,
  FETCH_TASK_QUEUE,
  FETCH_TASK_QUEUE_REALTOR,
  NO_TASKS,
  SEND_MESSAGE,
  SLACK_MESSAGE_SENT,
  TASK_SELECTED,
} from "../../_actions/types";

export const createTask = task => {
  console.log(task);
  return (dispatch, getState) => {
    const state = getState();
    const id = state.auth.user.uid;
    const email = state.auth.user.email;
    const phone = state.auth.phone;
    const Ref = firebaseApp
      .database()
      .ref(`tasks/`)
      .push();
    const Key = Ref.key;
    const updates = {};

    updates[`tasks/${Key}/title`] = task.title;
    updates[`tasks/${Key}/key`] = Key;
    updates[`tasks/${Key}/done`] = false;
    updates[`tasks/${Key}/inProgressUser`] = "";
    updates[`tasks/${Key}/details`] = task.details;
    updates[`tasks/${Key}/dueDate`] = task.dueDate;
    updates[`tasks/${Key}/userId`] = id;
    updates[`tasks/${Key}/users/${id}`] = true;
    updates[`tasks/${Key}/userEmail`] = email;
    updates[`tasks/${Key}/fileCount`] = 0;
    updates[`tasks/${Key}/timerTotal`] = 0;
    updates[`tasks/${Key}/phone`] = phone;
    updates[`users/${id}/tasks/${Key}`] = true;
    firebaseApp
      .database()
      .ref()
      .update(updates)
      .then(dispatch({ type: CREATE_TASK }));
  };
};

export const deleteTask = (task) => {
  return (dispatch, getState) => {
    const state = getState();
    const id = state.auth.user.uid;
    const updates = {}
    updates[`tasks/${task}`] = null
    updates[`users/${id}/tasks/${task}/`] = null
    firebaseApp
      .database()
      .ref()
      .update(updates)
      .then(dispatch({ type: DELETE_TASK }));
  };
};

export const selectTask = task => {
  return {
    type: TASK_SELECTED,
    payload: task
  };
};

export const fetchTaskQueueRealtor = () => {
  return (dispatch, getState) => {
    const state = getState();
    const id = state.auth.user.uid;
    firebaseApp
      .database()
      .ref(`tasks/`)
      .on("value", snapshot => {
        let newObject = [];
        if (snapshot.val() !== null) {
          newObject = Object.values(snapshot.val()).filter(task =>
            task.users.hasOwnProperty(id)
          );
        }
        dispatch({ type: FETCH_TASK_QUEUE_REALTOR, tasks: newObject })
      });
  };
};

export const fetchTaskQueue = (
  specialty,
  assigned = false,
  done = false,
  email = 0
) => {
  return (dispatch, getState) => {
    firebaseApp
      .database()
      .ref(`tasks/`)
      .on("value", snapshot => {
        const taskQueue = [];
        if (snapshot.val() !== null) {
              Object.values(snapshot.val()).forEach(task => {
                if (assigned && !done) {
                  if (task.inProgressUser === email && !task.done) {
                    taskQueue.push(task);
                  }
                } else if (assigned && done) {
                  if (task.inProgressUser === email && task.done) {
                    taskQueue.push(task);
                  }
                } else {
                  if (
                    (task.type === undefined || task.type === specialty) &&
                    task.inProgressUser === ""
                  ) {
                    taskQueue.push(task);
                  }
                }
              });
              dispatch({ type: FETCH_TASK_QUEUE, payload: taskQueue });
            }
        }
      );
  };
};

export const sendMessage = (message, senderID, activeTask) => {
  return dispatch => {
    const Ref = firebaseApp
      .database()
      .ref(`tasks/${activeTask.key}/messages/`)
      .push();
    const Key = Ref.key;
    const updates = {};
    const now = new Date();
    const now_utc = new Date(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds()
    );

    const chatMessage = {
      _id: `_${Math.random()
        .toString(36)
        .substr(2, 9)}`,
      text: message,
      createAt: now_utc,
      user: {
        _id: senderID
      }
    };

    updates[
      `/tasks/${activeTask.key}/messages/${Key}`
    ] = chatMessage;

    firebaseApp
      .database()
      .ref()
      .update(updates)
      .then(() => {
        firebaseApp
          .database()
          .ref(`tasks/${activeTask.key}/`)
          .on("value", snapshot => {
            dispatch(
              selectTask({
                ...activeTask,
                messages: snapshot.val().messages
              })
            );
          });
      }).then(() => {
        const sendMessage = firebaseApp.functions().httpsCallable('sendMessage')
        let recipient;
        Object.keys(activeTask.users).forEach(user => {
          if (user !== senderID) {
            recipient = user;
          }
        })
        sendMessage({recipient, message, now_utc})
      })
  };
};

export const handleFiles = (doc, activeTask) => {
  const { key } = activeTask;
  return (dispatch, getState) => {
    const storageRef = firebaseApp.storage().ref();
    storageRef
      .child(`files/${key}/${doc.name}`)
      .put(doc)
      .then(snapshot => {
        const downloadURL = snapshot.ref.getDownloadURL();
        console.log(downloadURL)
        const Ref = firebaseApp
          .database()
          .ref(`tasks/${key}/files`)
          .push();
        const Key = Ref.key;
        const updates = {};
        updates[`tasks/${key}/files/${Key}/name`] =
          doc.name;
        updates[
          `tasks/${key}/files/${Key}/link`
        ] = downloadURL;
        updates[`tasks/${key}/files/${Key}/key`] = Key;
        firebaseApp
          .database()
          .ref()
          .update(updates)

        firebaseApp
          .database()
          .ref(`tasks/${key}/`)
          .on("value", snapshot => {
            dispatch(
              selectTask({
                ...activeTask,
                files: snapshot.val().files
              })
            );
          });
      });
  };
};

export const handleDeleteFile = (doc, activeTask) => {
  const { key } = activeTask;
  return dispatch => {
    const storageRef = firebaseApp.storage().ref();
    storageRef
      .child(`files/${key}${doc.name}`)
      .delete()
      .then(() => {
        firebaseApp
          .database()
          .ref(`tasks/${key}/files/${doc.key}`)
          .remove();

        firebaseApp
          .database()
          .ref(`tasks/${key}/`)
          .on("value", snapshot => {
            dispatch(
              selectTask({
                ...activeTask,
                files: snapshot.val().files
              })
            );
          });
      });
  };
};

export const markDone = activeTask => {
  const { projectID, key } = activeTask;
  return dispatch => {
    const updates = {};
    updates[`projects/${projectID}/tasks/${key}/done`] = true;
    firebaseApp
      .database()
      .ref()
      .update(updates);

    firebaseApp
      .database()
      .ref(`projects/${projectID}/tasks/${key}/`)
      .on("value", snapshot => {
        dispatch(
          selectTask({
            ...activeTask,
            done: snapshot.val().done
          })
        );
      });
  };
};

export const sendNotification = (activeTask, notification) => {
  const {
    userId,
    title
  } = activeTask;
  return dispatch => {
    const Ref = firebaseApp
      .database()
      .ref(`users/${userId}/notifications/`)
      .push();
    const Key = Ref.key;
    const updates = {};
    updates[`users/${userId}/notifications/${Key}/message`] = notification;
    updates[`users/${userId}/notifications/${Key}/task`] = title;
    firebaseApp
      .database()
      .ref()
      .update(updates);
  };
};

export const stopOnboarding = () => {
  return (dispatch, getState) => {
    const state = getState();
    const id = state.auth.user.uid;
    const updates = {};
    updates[`users/${id}/onboarding`] = false;
    firebaseApp
      .database()
      .ref()
      .update(updates);
  };
};

export const uploadFile = (task, meta) => {};

export const uploadImage = () => {};



// WEBPACK FOOTER //
// ./src/components/project/project_actions.js